import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../common/Header";
import { updateLoginPopupVisible } from "../common/Redux/login";
import WorkRecordWrapper from "./WorkRecord/WorkRecordWrapper";

import "./index.css";
import Report from "./Report";
import { hasPermission } from "../../utils/hasPermission";
import { PERM } from "../../utils/permissions";

export default function WorkingTimeTable() {
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();

  const canSeeReport = hasPermission(userInfo.permissions, PERM.WR_REPORT);

  // const menuDataSource = [
  //   { id: "workRecord", name: "Work Record", icon: "fa-solid fa-file-lines", selected: true },
  //   { id: "report", name: "Report", icon: "fa-solid fa-file-waveform", disabled: !canSeeReport },
  // ];
  const [menuDataSource, setMenuDataSource] = useState(null);

  useEffect(() => {
    const menu = [
      { id: "workRecord", name: "Work Record", icon: "fa-solid fa-file-lines", selected: true },
      { id: "report", name: "Report", icon: "fa-solid fa-file-waveform", disabled: !canSeeReport },
    ];
    setMenuDataSource(menu);
  }, []);

  const [cMenu, setCMenu] = useState("workRecord");

  useEffect(() => {
    document.title = "Work Record";
    if (userInfo.employeeNo == null) {
      dispatch(updateLoginPopupVisible(true));
    }
  }, []);

  return (
    <React.Fragment>
      <Header
        title="WORK RECORD"
        menuDataSource={menuDataSource}
        setCMenu={setCMenu}
      />
      <div style={{ margin: "40px auto", width: "95vw" }}>
        {cMenu == "workRecord" ? <WorkRecordWrapper /> : <Report />}
      </div>

      {/* {userInfo.employeeNo && (
        <div>
          <Box direction="row" width={"100%"}>
            {(userInfo.div == "CO" ||
              userInfo.div == "DM" ||
              userInfo.div == "SA" ||
              userInfo.div == "MW") && (
              <Item ratio={0} baseSize={300}>
                <ProjectListComponent
                  resourceDataSource={resourceDataSource}
                  setResourceDataSource={setResourceDataSource}
                />
              </Item>
            )}
            <Item ratio={1}>
              <SchedulerComponent resourceDataSource={resourceDataSource} />
            </Item>
          </Box>
        </div>
      )} */}
    </React.Fragment>
  );
}
